<template>
  <div>
    <c-modal
      v-if="showModal"
      title="Speaker Details"
      size="lg"
      @close="closeModal"
    >
      <div class="modal-body">
        <speaker-item
          :is-modal="true"
          @closeModal="closeModal"
          :name="speaker.name"
          :title="speaker.title"
          :photo="speaker.photo_url"
          :description="bio"
          :sessions="sessions"
        />
      </div>
      <div class="modal-footer">
        <c-button
          theme="default"
          size="md"
          icon="fa-close"
          @click="closeModal"
          uppercase
          fill
        >Close</c-button>
      </div>
    </c-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {attendeeFetchData} from "../../../api";
import SpeakerItem from "../../speakers/speaker-item/index";

export default {
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    speaker: {
      type: Object,
      default: null
    },
  },
  components: {
    SpeakerItem,
  },
  computed: {
    ...mapGetters('attendeeStore', ['attendee']),
  },
  mounted() {
    const url = `/api/v2/attendees/${this.attendee.attendee_id}/speakers/${this.speaker.id}`;

    attendeeFetchData(url)
      .then(res => {
        this.bio = res.data?.data?.bio;
        this.sessions = res.data?.data?.sessions;
      })
  },
  data() {
    return {
      bio: '',
      sessions: [],
    }
  },
  methods: {
    closeModal() {
      this.$emit('update:showModal', false)
    }
  }
}
</script>
